import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { LoadingService } from './data-access-layer/services/loading.service';
import { NotificationComponent } from './view-layer/components/notification.component';
import { AlertService } from './data-access-layer/services/alert.service';
import { AppConfigService } from './app-config.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private loadingService: LoadingService,
    private alertService: AlertService,
    private appConfig: AppConfigService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let config = new MatSnackBarConfig();
    config.duration = 5000;
    const snackbar = inject(MatSnackBar);

    let loadingTimeout: any;
    this.loadingService.setLoading(false);

    loadingTimeout = setTimeout(() => {
      if (req.responseType !== 'blob') {
        this.loadingService.setLoading(true);
      }
    }, 100);

    return next.handle(req).pipe(
     
      // Обработка ошибок
      catchError((error: HttpErrorResponse) => {
        let message = '';
        console.log(error)
        if (error.error && error.error.status === 400) {
          if (error.error.errors) {
            for (const err of Object.values(error.error.errors)) {
              message += `${err}\n`;
            }
          } else {
            message = 'Некорректные данные';
          }
          config.data = { "firstLine": message };
          snackbar.openFromComponent(NotificationComponent, config);
          const pythonUrl = this.appConfig.pythonUrl?.replace(/\/$/, '') || '';
          const isPythonApiError = pythonUrl && error.url?.startsWith(pythonUrl);
          console.log(pythonUrl, isPythonApiError)
          console.log(pythonUrl)
        } else {
            let err = error.error;
            message = err;
            if (err?.error)
              message = err.error;
            if (err?.detail)
              message = err.detail;
          const displayMessage = typeof message === 'string' ? message : JSON.stringify(message);
          const isUselessMessage = displayMessage === 'true' || displayMessage === 'false' || !displayMessage || displayMessage === '{}';
          const isCheckConnection = error.url?.includes('check_connection') === true;
          if (!isCheckConnection) {
            this.alertService.error(
              'Ошибка во время обновления',
              isUselessMessage ? 'Произошла ошибка. Проверьте настройки или попробуйте позже.' : displayMessage
            );
          }
        }

        return throwError(error);
      }),
      finalize(() => {
        clearTimeout(loadingTimeout);
        this.loadingService.setLoading(false);
      })
    );
  }
}
